import type {
  RadioGroupItemProps,
  RadioGroupProps,
} from '@radix-ui/react-radio-group';
import * as RadixRadioGroup from '@radix-ui/react-radio-group';
import clsx from 'clsx';
import type { CSSProperties, Ref } from 'react';

import { RadioGroup } from '../radio';
import * as styles from './styles.css';

RadioGroup;

/**
 * @deprecated
 * use {@link RadioGroup } instead
 */
export const RadioButton = ({
  ref,
  children,
  className,
  spanStyle,
  ...props
}: RadioGroupItemProps & { spanStyle?: string; ref?: Ref<HTMLButtonElement> }) => {
  return (
    <RadixRadioGroup.Item
      ref={ref}
      {...props}
      className={clsx(styles.radioButton, className)}
    >
      <span className={clsx(styles.radioUncheckedButton, spanStyle)}>
        {children}
      </span>
      <RadixRadioGroup.Indicator
        className={clsx(styles.radioButtonContent, spanStyle)}
      >
        {children}
      </RadixRadioGroup.Indicator>
    </RadixRadioGroup.Item>
  );
};

/**
 * @deprecated
 * use {@link RadioGroup} instead
 */
export const RadioButtonGroup = ({
  ref,
  className,
  style,
  width,
  ...props
}: RadioGroupProps & { width?: CSSProperties['width']; ref?: Ref<HTMLDivElement> }) => {
  return (
    <RadixRadioGroup.Root
      ref={ref}
      className={clsx(styles.radioButtonGroup, className)}
      style={{ width, ...style }}
      {...props}
    ></RadixRadioGroup.Root>
  );
};
